import React, { useEffect, useState, useMemo, useCallback } from "react";
import Sidebar from "./Sidebar";
import { API_BASE_URL } from "../config";
import { Session } from "./utils/session";

export default function TaskTimeReport() {

  const [showMobileSidebar, setShowMobileSidebar] = useState(false);
  const [hideDesktop, setHideDesktop] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [taskName, setTaskName] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const authHeaders = useMemo(() => ({
    Authorization: `Bearer ${Session.getToken()}`,
    "Content-Type": "application/json"
  }), []);

  const loadReport = useCallback(async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams();
      if (taskName) params.append("taskName", taskName);
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);

      const res = await fetch(
        `${API_BASE_URL}/api/TimeReports/TaskTimeReport_List?${params}`,
        { headers: authHeaders }
      );

      if (!res.ok) {
        console.error("API Error:", res.status);
        return;
      }

      const result = await res.json();
      setData(Array.isArray(result) ? result : []);

    } catch (err) {
      console.error("Report load error:", err);
    }
    finally {
  setLoading(false);
}
  }, [taskName, startDate, endDate, authHeaders]);

  useEffect(() => { loadReport(); }, [loadReport]);

   useEffect(() => {
     const overlay = document.getElementById('sidebar-overlay');
     if (overlay) {
       overlay.style.display = showMobileSidebar ? 'block' : 'none';
     }
     const sidebar = document.getElementById('sidebar');
     if (sidebar) {
       if (showMobileSidebar) sidebar.classList.add('show-mobile');
       else sidebar.classList.remove('show-mobile');
       if (hideDesktop) sidebar.classList.add('hide-desktop');
       else sidebar.classList.remove('hide-desktop');
     }
     const content = document.getElementById('content');
     if (content) {
       if (hideDesktop) content.classList.add('full-width');
       else content.classList.remove('full-width');
     }
   }, [showMobileSidebar, hideDesktop]);
 
   const toggleSidebar = () => {
     if (window.innerWidth <= 991) {
       setShowMobileSidebar((s) => !s);
     } else {
       setHideDesktop((s) => !s);
     }
   };

  return (
    <div>
      <div id="sidebar-overlay" onClick={() => setShowMobileSidebar(false)} />
      <div id="sidebar"><Sidebar /></div>

      <div id="content">
        <div className="d-flex align-items-center mb-3">
          <button type="button" id="sidebarCollapse" className="btn btn-toggle" onClick={toggleSidebar} aria-label="Toggle sidebar">
              <i className="fas fa-bars" />
            </button>
          <span className="text-muted small">
            <i className="fas fa-chevron-left" /> Back
          </span>
        </div>

        <h2 className="mb-4 fw-bold">Task Time Report</h2>

        <div className="main-card">
          <div className="panel panel-default">
            <div className="panel-body p-4">

              <div className="row mb-4 align-items-end">

                <div className="col-md-4">
                  <label className="form-label">Task</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Task Name"
                    value={taskName}
                    onChange={(e) => setTaskName(e.target.value)}
                  />
                </div>

              <div className="col-md-4">
                <label className="form-label">Start Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={startDate}
                  max={endDate || ""}
                  onChange={(e) => setStartDate(e.target.value)}
                />
              </div>

              <div className="col-md-4">
                <label className="form-label">End Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={endDate}
                  min={startDate || ""}
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </div>

              </div>
              {loading ? (
                <div className="d-flex justify-content-center align-items-center" style={{ height: "60vh" }}>
                  <img src="/Images/loader.gif" alt="loading" style={{ width: "80px" }} />
                </div>
              ) : (
              <table className="table table-custom table-hover">
                <thead>
                  <tr>
                    <th>User</th>
                    <th>Task</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Total Time</th>
                  </tr>
                </thead>

                <tbody>

                  {data.length === 0 && (
                    <tr>
                      <td colSpan="5" className="text-center text-muted py-3">
                        No Data Found
                      </td>
                    </tr>
                  )}

                  {data.map((item, i) => {
                    const isTotal = item.userName === "TOTAL";

                    return (
                      <tr
                        key={i}
                        style={{
                          fontWeight: isTotal ? "bold" : "normal",
                          backgroundColor: isTotal ? "#f8f9fa" : "transparent"
                        }}
                      >
                        <td>{item.userName}</td>
                        <td>{isTotal ? "" : item.taskName}</td>

                        <td>
                          {isTotal ? "" :
                            item.startDateTime
                              ? new Date(item.startDateTime).toLocaleString()
                              : "-"
                          }
                        </td>

                        <td>
                          {isTotal ? "" :
                            item.endDateTime
                              ? new Date(item.endDateTime).toLocaleString()
                              : "-"
                          }
                        </td>

                        <td style={{ color: isTotal ? "#0d6efd" : "inherit" }}>
                          {item.totalTime}
                        </td>

                      </tr>
                    );
                  })}

                </tbody>
              </table>
)}
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}